import { render, staticRenderFns } from "./kyc_step_four.vue?vue&type=template&id=12d849dc&scoped=true"
import script from "./kyc_step_four.vue?vue&type=script&lang=js"
export * from "./kyc_step_four.vue?vue&type=script&lang=js"
import style0 from "./kyc_step_four.vue?vue&type=style&index=0&id=12d849dc&prod&scoped=true&lang=css"
import style1 from "./kyc_step_four.vue?vue&type=style&index=1&id=12d849dc&prod&lang=css"
import style2 from "./kyc_step_four.vue?vue&type=style&index=2&id=12d849dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d849dc",
  null
  
)

export default component.exports